// extracted by mini-css-extract-plugin
export default {"wrapper":"IronsRecommendation_wrapper__SHIa5"};